import { RouteConfig } from 'vue-router'
import CalendarView from '../views/CalendarView.vue'
import ReadView from '../views/ReadView.vue'
import WriteView from '../views/WriteView.vue'
import EditView from '../views/EditView.vue'
import RecurringView from '../views/RecurringView.vue'
const Calendar = () => import(/* webpackChunkName: "calendar" */ '@calendar/Index.vue')
const CalendarMaster = () => import(/* webpackChunkName: "calendar" */ '@calendar/views/Master.vue')

const routes: RouteConfig[] = [
  {
    path: '/calendar',
    component: Calendar,
    children: [
      {
        path: '',
        component: CalendarMaster,
        children: [
          {
            path: 'main',
            name: 'calendar-main',
            component: CalendarView,
          },
          {
            path: 'read',
            name: 'calendar-read',
            component: ReadView,
          },
          {
            path: 'write',
            name: 'calendar-write',
            component: WriteView,
          },
          {
            path: 'edit',
            name: 'calendar-edit',
            component: EditView,
          },
          {
            path: 'recurring',
            name: 'calendar-recurring',
            component: RecurringView,
          },
        ],
      },
    ],
  },
]
export default routes
